import { render, staticRenderFns } from "./HallsTab.vue?vue&type=template&id=20de9a1a&scoped=true&"
import script from "./HallsTab.vue?vue&type=script&lang=js&"
export * from "./HallsTab.vue?vue&type=script&lang=js&"
import style0 from "./HallsTab.vue?vue&type=style&index=0&id=20de9a1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20de9a1a",
  null
  
)

export default component.exports